"use client";

import { useSyncExternalStore } from "react";
import { Eye } from "lucide-react";
import { isPreview, previewNow } from "@/lib/preview";
import { asLocalDate } from "@/lib/eventTime";

const never = () => () => {};
// in a window of its own only: inside the back-office's frame, the frame says it
const shown = () => isPreview() && window.top === window.self;

/**
 * Says a tab is a preview from the back-office (lib/preview.ts), and the moment it
 * pretends it is, so that a page showing another day is not taken for the real one.
 */
export function PreviewBadge() {
  const show = useSyncExternalStore(never, shown, () => false);
  if (!show) {
    return null;
  }
  const now = asLocalDate(previewNow());
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(var(--tabbar-h)+var(--safe-bottom)+8px)] z-[90] flex justify-center desk:bottom-3">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-ink/85 px-3 py-1.5 text-[12px] font-bold text-white shadow-card">
        <Eye size={14} /> Pré-visualização
        {now && <span className="font-normal">· {now.toLocaleString("pt-PT", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>}
      </span>
    </div>
  );
}
